import { secureExportToExcel } from './secureExcelUtils';

/**
 * Export data to Excel file
 * @param {Array} data - Array of objects to export
 * @param {String} fileName - Name of the file to download
 * @param {Array} columns - Array of column definitions with title and dataIndex
 */
export const exportToExcel = (data, fileName, columns) => {
  // Format data with column headers
  const formattedData = data.map(item => {
    const row = {};
    columns.forEach(column => {
      row[column.title] = item[column.dataIndex];
    });
    return row;
  });

  // Use the secure export utility
  secureExportToExcel(formattedData, `${fileName}.xlsx`);
};

/**
 * Format date for use in filenames
 * @returns {String} Formatted date string (YYYY-MM-DD)
 */
export const getFormattedDate = () => {
  const date = new Date();
  return date.toISOString().split('T')[0];
};
